
import React from 'react';
import { Container, Box } from '@material-ui/core';

import Page from 'src/components/Page';
import { doc,collection,query,where } from 'firebase/firestore';
import { useFirestoreDocData,useFirestore,useFirestoreCollectionData } from 'reactfire';
import { useLocation } from 'react-router-dom';
import {TemplatePreview} from '../template-preview';
import LoadingView from 'src/views/auth/LoadingView';
import {attendanceListsType} from '../model';
import {UserType} from 'src/views/user-management/model';


export const AttendanceSingleScreen = ()=>{

  const db = useFirestore();
  const {pathname} = useLocation();
  const attendanceID = pathname.split('/')[pathname.split('/').length-1];
  const { status:attendanceStatus, data:attendanceData } = useFirestoreDocData(
    doc(db, 'attendanceLists',attendanceID),
    {idField:'id'});
  const attendanceDataType = attendanceData as attendanceListsType;


  if(attendanceStatus==='loading'){
    return <LoadingView/>;
  }

  return (
    <Page title="Attendance">
      <Container>
        {!isNaN(attendanceData.group)&&<GroupUser attendanceData={attendanceDataType} groupNumber={attendanceDataType.group??10000}/>}
      </Container>
     
    </Page>
  );
};



export const GroupUser = ({groupNumber,attendanceData}:{groupNumber:number,attendanceData:attendanceListsType})=>{


  const groupCollection = collection(useFirestore(), 'users');
  const groupQuery = query(groupCollection, where('group', '==', groupNumber));
  const { data:groupData, error } = useFirestoreCollectionData(groupQuery, {
    idField: 'userId',
  });

  const groupDataWithType = groupData as unknown as UserType[];

  return (
    <Box display="flex" flexDirection="column" gridGap={16} mt={2} >
      <TemplatePreview showEditMode={true} group={groupNumber} groupMembers={groupDataWithType} date={attendanceData.date} attendanceItems={attendanceData.attendanceItems}/>
    </Box>
  );
};